module.exports = __webpack_public_path__ + "img/cyprus.7a05d214.svg";